import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import { Button, DropdownMenu, Link, List } from "atoms";
import { useAuth } from "features/auth";
import { Artist, Project } from "../types";

interface SecondaryMenuProps {
  reviewable: Artist | Project;
  toggleSecondaryMenu: () => void;
  isSecondaryMenuOpen: boolean;
  openReportForm: () => void;
}

function SecondaryMenu({
  toggleSecondaryMenu,
  isSecondaryMenuOpen,
  openReportForm,
  reviewable,
}: SecondaryMenuProps) {
  const {
    user,
    roles: { isQA, showAdminFeatures },
  } = useAuth();

  const userIsEditor = !!user && reviewable?.adminUsers?.includes(user?.id);
  const canEdit = showAdminFeatures || isQA || userIsEditor;

  const navigate = useNavigate();

  // If user selects menu option, the menu should close after event bubbles up
  // const closeSecondaryMenu: React.ReactEventHandler = (event) => {
  //   if (event.currentTarget !== event.target) {
  //     setIsSecondaryMenuOpen(false);
  //   }
  // };

  return (
    <SecondaryMenuWrapper>
      <SecondaryMenuToggle
        type="button"
        size="xxs"
        onClick={toggleSecondaryMenu}
        aria-label={`${isSecondaryMenuOpen ? "Close" : "Open"} options menu`}
        aria-controls="#options"
        aria-expanded={isSecondaryMenuOpen}
        variant="secondary"
      >
        •••
      </SecondaryMenuToggle>

      <SecondaryMenuDropdown isOpen={isSecondaryMenuOpen} id="options">
        <List type="blank">
          {canEdit && (
            <li>
              <Link
                to={`/${reviewable.type.toLowerCase()}s/${reviewable.id}/edit`}
              >
                Edit Profile
              </Link>
            </li>
          )}
          {reviewable.type === "ARTIST" && showAdminFeatures && (
            <li>
              <Link to={`/artists/${reviewable.id}/create-update`}>
                Post an Update
              </Link>
            </li>
          )}
          <li>
            <Button
              variant="blank"
              onClick={() => {
                openReportForm();
                navigate("#report-form");
                toggleSecondaryMenu();
              }}
            >
              Report a Problem
            </Button>
          </li>
        </List>
      </SecondaryMenuDropdown>
    </SecondaryMenuWrapper>
  );
}

const SecondaryMenuWrapper = styled.div({
  right: 0,
  display: "block",
  position: "relative",
  width: "min-content",
});

interface WithIsOpen {
  isOpen: boolean;
}

const SecondaryMenuToggle = styled(Button)({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  whiteSpace: "nowrap",
  letterSpacing: 2,
  paddingLeft: 12,
  paddingRight: 12,
  svg: {
    pointerEvents: "none",
  },
});

const SecondaryMenuDropdown = styled(DropdownMenu)<WithIsOpen>(
  ({ isOpen }) => ({
    display: isOpen ? "flex" : "none",
    minWidth: "200px",
    maxWidth: "285px",
  })
);

export { SecondaryMenu };
